import { Trans } from '@/components'
import { Modal } from '@/components/base/Modal'

interface ForgotTeamPasswordModalProps {
  open: boolean
  onClose: () => void
}

export function ForgotTeamPasswordModal({ open, onClose }: ForgotTeamPasswordModalProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>
        <Trans i18nKey="teamLogin.forgotPasswordModalTitle">Forgot Password?</Trans>
      </Modal.Header>
      <Modal.Body>
        <Trans i18nKey="teamLogin.forgotPasswordModalContent">
          Please contact your team administrator to reset your password
        </Trans>
      </Modal.Body>
    </Modal>
  )
}
